import { useMemo } from 'react'
import useCreateQueryString from '@/app/core/hooks/createQueryString'
import { BasicTeam, Team } from '@/dc-shared-web/src'
import {
  ALL_TEAMS_OPTION,
  SELECTED_TEAM_ID_KEY,
} from '@dc-shared-web/lib/constants'

type TeamData = Team | BasicTeam

export function isTeam(data: TeamData): data is Team {
  return (data as Team).name !== undefined
}

export function isBasicTeam(data: TeamData): data is BasicTeam {
  return (data as BasicTeam).uuid !== undefined
}

const getTeamData = (selectedTeamId: string, teams: Team[]): TeamData => {
  const found = teams.find((team) => String(team.id) === selectedTeamId)

  return found ?? ALL_TEAMS_OPTION
}

export const useGetSelectedTeamData = (teams: Team[]) => {
  const { searchParams } = useCreateQueryString()
  const selectedTeamId = searchParams.get(SELECTED_TEAM_ID_KEY)

  const teamData = useMemo(() => {
    return getTeamData(selectedTeamId || '', teams)
  }, [selectedTeamId, teams])

  return teamData
}
